angular
    .module('vm.helpCenter')
    .directive('dropZone', dropZone);

function dropZone() {
    return {
        restrict : "A",
        scope: {
            'addFiles': '&'
        },
        link: function (scope, element) {
            element.bind('dragover', function(event) {
                event.preventDefault();
                event.stopPropagation();
            });
            element.bind('dragenter', function(event) {
                event.preventDefault();
                event.stopPropagation();
            });
            
            element.bind('drop', function(event) {
                event.stopPropagation();
                event.preventDefault();
                scope.addFiles({files: event.dataTransfer.files});
            });
        }
    }
}